<template>
    <td-dialog
        :lockScroll="false"
        :title="$t(title)"
        :before-close="previewDialogClose"
        :visible.sync="dialogVisible"
        width="1180px"
        :close-on-click-modal="false"
        :close-on-press-escape="false"
        top="18vh"
    >
        <el-container>
            <el-form class="previewFormWith" ref="dynamicPreviewForm">
                <td-dynamic ref="tdDynamic" labelWidth="150px" :groupFlg="groupFlg" v-model="groupElementValue"> </td-dynamic>
            </el-form>
        </el-container>
        <span slot="footer">
            <td-button type="primary" @click="submitForm()" :loading="submitLoading">{{ $t('extendCommon.SAVE') }}</td-button>
            <td-button @click="previewDialogClose">{{ $t('extendCommon.CANCEL') }}</td-button>
        </span>
    </td-dialog>
</template>
<script>
import previewApi from './../assets/api.js';
export default {
    props: ['title', 'dialogVisible', 'groupFlg', 'groupElementValue'],
    created() {},
    // 定义变量
    data() {
        return {
            submitLoading: false,
            // db表单信息
            formInfo: {}
        };
    },
    // 定义并实现方法体
    methods: {
        carTypeChange(data) {
            this.$log.info(data);
            alert(data);
        },
        submitForm() {
            this.formInfo = this.$refs.tdDynamic.getfromInfo();
            this.$refs.tdDynamic.$refs.dynamicForm.validate(valid => {
                if (valid) {
                    this.submitLoading = true;
                    var content = {
                        sGroupFlg: this.groupFlg,
                        extendValue: JSON.stringify(this.formInfo)
                    };
                    previewApi.insertExtendValue(JSON.stringify(content), response => {
                        if (response.data.statusCode !== window.vue.$common.requestCode.SUCCESS_INFO_CODE) {
                            this.$message({ showClose: true, message: response.data.statusMessage, type: 'error' });
                            this.$log.error('extendManage/insertExtendValue', response.data.statusMessage);
                            this.submitLoading = false;
                            return;
                        }
                        this.submitLoading = false;
                        this.$message({ showClose: true, message: this.$t('extendCommon.MODIFY_SUCCESS'), type: 'success' });
                        this.previewDialogClose();
                    });
                }
            });
        },
        // 关闭窗口之前需要调用的方法
        previewDialogClose() {
            this.$emit('previewDialogClose');
        }
    }
};
</script>
<style scoped>
.previewFormWith {
    width: 100%;
}
</style>
